function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "question icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "question icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3812",
    style: {
      fill: "none"
    },
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.75 44-.5-5.5h-2a16.622 16.622 0 0 1-12.2-5.05A16.622 16.622 0 0 1 6 21.25a16.581 16.581 0 0 1 5.075-12.2A16.763 16.763 0 0 1 23.35 4a16.756 16.756 0 0 1 6.575 1.275A15.981 15.981 0 0 1 35.2 8.85a16.673 16.673 0 0 1 3.525 5.425A17.9 17.9 0 0 1 40 21.1a23.192 23.192 0 0 1-.975 6.6A25.99 25.99 0 0 1 36.2 34a28.321 28.321 0 0 1-4.5 5.55A30.45 30.45 0 0 1 25.75 44zm-2.4-11.15A1.878 1.878 0 1 0 22 32.3a1.835 1.835 0 0 0 1.35.55zM22 26.05h2.5a4.508 4.508 0 0 1 .425-2.075A9.975 9.975 0 0 1 26.7 21.8a9.736 9.736 0 0 0 1.9-2.475 5.447 5.447 0 0 0 .55-2.425 4.883 4.883 0 0 0-1.525-3.7 5.669 5.669 0 0 0-4.075-1.45 6.576 6.576 0 0 0-6.2 4.1l2.3.95a4.092 4.092 0 0 1 1.525-1.925 4.033 4.033 0 0 1 2.225-.625 3.508 3.508 0 0 1 2.35.725 2.4 2.4 0 0 1 .85 1.925 3.9 3.9 0 0 1-.55 1.925 13.042 13.042 0 0 1-1.95 2.425 8.909 8.909 0 0 0-1.725 2.25A6.623 6.623 0 0 0 22 26.05z",
    transform: "translate(1)",
    style: {
      fill: "#758091"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.4fee9f3f01a55933fa30e959e8abbc7d.svg";
export { ForwardRef as ReactComponent };